module.exports = __webpack_public_path__ + "img/stackslash-inspect-medium.cdcdaf33.jpg";